/* global axios */

import ApiClient from './ApiClient';

class WhatsappInteractiveMessageTemplatesAPI extends ApiClient {
  constructor() {
    super('whatsapp_interactive_message_templates', {
      accountScoped: true,
    });
  }

  createTemplate(template) {
    return axios.post(this.url, {
      whatsapp_interactive_message_template: template,
    });
  }

  updateTemplate(id, template) {
    return axios.patch(`${this.url}/${id}`, {
      whatsapp_interactive_message_template: template,
    });
  }
}

export default new WhatsappInteractiveMessageTemplatesAPI();
